import { render, staticRenderFns } from "./popGoodsAmount.vue?vue&type=template&id=b9a8ac88"
import script from "./popGoodsAmount.vue?vue&type=script&lang=js"
export * from "./popGoodsAmount.vue?vue&type=script&lang=js"
import style0 from "./popGoodsAmount.vue?vue&type=style&index=0&id=b9a8ac88&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b9a8ac88')) {
      api.createRecord('b9a8ac88', component.options)
    } else {
      api.reload('b9a8ac88', component.options)
    }
    module.hot.accept("./popGoodsAmount.vue?vue&type=template&id=b9a8ac88", function () {
      api.rerender('b9a8ac88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/orderBox/saleOrder/components/popGoodsAmount/popGoodsAmount.vue"
export default component.exports